define('SageDotCom/Components/Content/GenericToggleSwitcher',["jquery", "SageDotCom/Utility/gatedContentHelper"],
    function ($, gatedContentHelper) {
        function GenericToggleSwitcher(scope) {
            const toggleSwitcherElement = $("#sage-toggle-switcher-checkbox", scope);

            function updateGatedContent() {
                gatedContentHelper.unLoadGatedContent(document.querySelector('body'));
                gatedContentHelper.loadGatedContent(document.querySelector('body'));
            }

            toggleSwitcherElement.on("change",
                function () {
                    const toggleChecked = $(this).is(":checked");
                    var toggleSwitcherWrapper = $(this).closest(".sage-toggle-switcher-wrapper");

                    if (toggleChecked) {
                        toggleSwitcherWrapper.addClass("right-side");
                    } else {
                        toggleSwitcherWrapper.removeClass("right-side");
                    }

                    setTimeout(updateGatedContent, 0);
                });
        }

        GenericToggleSwitcher.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new GenericToggleSwitcher(args.scope);
        };

        return GenericToggleSwitcher;
    });
